
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 720 360"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#da121a","d":"M0 0h720v360H0z"}}),_c('path',{attrs:{"fill":"#fcdd09","d":"M0 0h720v240H0z"}}),_c('path',{attrs:{"fill":"#078930","d":"M0 0h720v120H0z"}}),_c('g',{attrs:{"transform":"translate(360 180)"}},[_c('circle',{attrs:{"fill":"#0f47af","r":"120"}}),_c('g',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#fcdd09","d":"M0-96l-4.206 12.944 17.348 53.39h-23.13l-2.599 8h74.163l11.011-8H21.553z"}}),_c('path',{attrs:{"stroke":"#fcdd09","stroke-width":"4","d":"M25.863-35.597l30.564-42.069"}})]),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(216)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(288)"}})])])
          )
        }
      }
    